"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useId = void 0;

var _react = require("react");

var _nanoid = require("nanoid");

/**
 * A hook that returns the same random ID string on every render.
 * Can be used as a value for HTML "id" attributes.
 * @returns random ID string
 */
var useId = function useId() {
  return (0, _react.useRef)((0, _nanoid.nanoid)()).current;
};

exports.useId = useId;